export default {
	process: {
		create: "Neuer Prozess",
		edit: "Prozess bearbeiten",
		explicitLayout: "Nur die Panels anzeigen, die dieser Prozess ausgibt",
		explicitLayoutHint:
			"Ausgeschaltet zeigt der Operator immer das Graphly-Diagramm, die Lumina-Ansicht und die Fragenliste, wie vor der Einführung der Panels. Eingeschaltet zeigt er nur die Panels, die der Prozess ausgibt — Graphly, Lumina, Fragenliste und Vorschlagspool stammen aus der Palette. Gibt ein Prozess keine Panels aus, bleibt der Operator leer.",
		deleteConfirm: "Prozess „{name}“ löschen?",
		name: "Prozessname",
		search: "Prozesse suchen…",
		noResults: "Keine Prozesse entsprechen Ihrer Suche.",
		empty: {
			title: "Noch keine Prozesse",
			hint: "Erstellen Sie einen Prozess, um einen operativen Ablauf zu modellieren.",
		},
		loadFailed: {
			title: "Dieser Prozess konnte nicht geöffnet werden",
			hint: "Möglicherweise wurde er gelöscht, oder Sie haben keinen Zugriff darauf.",
			back: "Zurück zu den Prozessen",
		},
		// What this process may do to the other processes of its dataspace (ProcessGrantsEditor).
		grants: {
			title: "Zugriff auf andere Prozesse",
			hint: "Was dieser Prozess während des Laufs mit anderen Prozessen tun darf, festgelegt je Prozessdefinition. Sich selbst darf er immer stoppen, neu starten, archivieren oder löschen. Ein laufender Prozess liest dies beim Start, eine Änderung betrifft also die Instanzen, die nach dem nächsten Build des Projekts gestartet werden.",
			own: "Andere Instanzen von {label}",
			missing: "Ein entfernter Prozess ({id})",
			selectAll: "Alle auswählen",
			badge: "{n} Zugriff | {n} Zugriffe",
			badgeTitle:
				"Darf auf {n} Prozessdefinition zugreifen | Darf auf {n} Prozessdefinitionen zugreifen",
			operations: {
				spawn: "Starten",
				send_event: "Ereignisse senden",
				list: "Auflisten",
				stop: "Stoppen",
				restart: "Neu starten",
				archive: "Archivieren",
				delete: "Löschen",
			},
			operationHints: {
				spawn: "Neue Instanzen starten.",
				send_event: "Ein Ereignis an eine Instanz oder an jede laufende senden.",
				list: "Sehen, welche Instanzen es gibt und in welchem Zustand sie sind.",
				stop: "Eine Instanz stoppen.",
				restart: "Eine Instanz neu starten.",
				archive: "Eine Instanz archivieren und wieder zurückholen.",
				delete: "Eine Instanz löschen.",
			},
		},
		sidebar: {
			tabsLabel: "Datenobjekt-Abschnitte",
			kindRoot: "Wurzel",
			kindRelated: "Verknüpft",
			readOnlyHint: "Sie können diesen Prozess ansehen, aber nicht ändern.",
			attachHint:
				"Um ein Datenobjekt zu verknüpfen, ziehen Sie dieses mit gedrückter {key}-Taste darauf.",
			attachTo: "Verknüpfen mit",
			attachSearch: "{target} in diesem Prozess suchen…",
			attachNoCandidates: "Keine passenden Datenobjekte in diesem Prozess.",
			// Siehe en/process.ts. „{target} anlegen" statt „Neue/r {target}": das Adjektiv
			// bräuchte das Genus des Begriffs, das wir nicht kennen.
			createNew: "{target} anlegen",
			createNewHint: "Wird in diesem Prozess angelegt und hier verknüpft.",
			createdTag: "Neu",
			createdNameIt: "Benennen",
			createdPlaced: "Auf der Leinwand neben diesem Datenobjekt platziert.",
			// Siehe en/process.ts.
			replace: "Ersetzen",
			replaceWith: "Ersetzen durch",
			replaceCancel: "Abbrechen",
			replaceKeeps: "{name} bleibt im Prozess, ohne Verknüpfung.",
			createReplaceHint:
				"Wird in diesem Prozess angelegt und tritt an die Stelle des bisherigen.",
			sharedShow: "Anzeigen",
			attachNoRelation: "{source} hat keine Beziehung zu {target}.",
			attachCycle:
				"{source} liegt bereits unter {target}, eine Verknüpfung würde einen Kreis bilden.",
			// Siehe en/process.ts: beide Hälften benennen, nicht nur das Ziel.
			attachMoved: "{name} von {from} getrennt und mit {to} verknüpft.",
			attachAlready: "Hier bereits verknüpft",
			attachReplaces: "Ersetzt {name}",
			// Siehe en/process.ts: die einzige Absage, die einem Ziehen bleibt.
			attachAlreadyThere: "{name} ist bereits mit {parent} verknüpft.",
			detach: "Trennen",
			summary: "Übersicht",
			relationsAttached: "Beziehungen verknüpft",
			activitiesAttached: "Aktivitäten verknüpft",
			activitiesAttachedHint:
				"{attached} von {available} verknüpft — über dieses Datenobjekt und alles darin Eingebettete, auch über geschlossene Abschnitte.",
			about: "Über diesen Prozess",
			noDescription: "Keine Beschreibung",
			dataobjects: "Datenobjekte",
			inProcess: "In diesem Prozess",
			availableToAdd: "Zum Hinzufügen verfügbar",
			activityCount: "keine Aktivitäten definiert | {count} Aktivität | {count} Aktivitäten",
			relatesTo: "in Beziehung zu {names}",
			placedHidden:
				"Durch Suche oder Filter ausgeblendet | Alle {count} durch Suche oder Filter ausgeblendet",
			search: "Datenobjekte suchen…",
			noMatches: "Keine Treffer",
			term: {
				renamed: "Name weicht vom Informationsmodell ab, dort heißt es „{term}“",
				inherited:
					"Verwendet aktuell den Namen aus dem Informationsmodell. Ein hier vergebener Name gilt nur für dieses Prozess-Datenobjekt.",
				modelTerm: "Im Informationsmodell: „{term}“",
				reset: "Modellnamen verwenden",
			},
			filter: {
				all: "Alle Datenobjekte",
				incomplete: "Nur unvollständige",
				hidden: "Nur unvollständige · keine ausgeblendet | Nur unvollständige · {count} ausgeblendet | Nur unvollständige · {count} ausgeblendet",
				showAll: "Alle anzeigen",
			},
			sort: {
				title: "Sortieren nach",
				attention: "Handlungsbedarf",
				suggested: "Vorgeschlagen",
				alphabetical: "A–Z",
				added: "Hinzugefügt",
			},
		},
		dataobjects: {
			pick: "Datenobjekt zum Prozess hinzufügen",
			addTitle: "Datenobjekt hinzufügen",
			remove: "Aus Prozess entfernen",
			removeConfirm:
				"„{name}“ aus diesem Prozess entfernen? Das lässt sich nicht rückgängig machen.",
			removeConfirmAttached:
				"„{name}“ und das {count} darunter verknüpfte Datenobjekt entfernen? Das lässt sich nicht rückgängig machen. | „{name}“ und die {count} darunter verknüpften Datenobjekte entfernen? Das lässt sich nicht rückgängig machen.",
			empty: {
				title: "Noch keine Datenobjekte in diesem Prozess",
				hint: "Doppelklicken Sie auf die Leinwand, um ein Wurzel-Datenobjekt hinzuzufügen, oder verwenden Sie die Schaltfläche unten.",
			},
			noneAvailable: "Keine Datenobjekte zum Hinzufügen verfügbar.",
		},
		activities: {
			attached: "Verknüpft",
			available: "Verfügbar",
			attachAll: "Alle verknüpfen",
			detachAll: "Alle trennen",
			actionCount: "{count} Aktion | {count} Aktionen",
			noActions: "noch keine Aktionen",
			open: "Aktivität öffnen",
			openReadOnly: "Aktivität öffnen (schreibgeschützt)",
			search: "Aktivitäten suchen…",
			noneForDataobject: "Für dieses Datenobjekt sind keine Aktivitäten definiert.",
			noneAttached: "nichts verknüpft",
			noneDefined: "keine Aktivitäten definiert",
			// Siehe en/process.ts. „verknüpfen“ statt „zuordnen“, weil die Zeile darüber
			// schon so heißt.
			noneAttachedHint:
				"Für {dataobject} ist {count} Aktivität definiert, hier läuft aber keine. Öffnen Sie dieses Datenobjekt, um eine zu verknüpfen. | Für {dataobject} sind {count} Aktivitäten definiert, hier läuft aber keine. Öffnen Sie dieses Datenobjekt, um eine zu verknüpfen.",
			noneDefinedHint:
				"Für {dataobject} sind keine Aktivitäten definiert. Legen Sie im Aktivitätseditor eine an, falls hier etwas laufen soll.",
			// Siehe en/process.ts.
			embeddedOnly:
				"{count} läuft auf einem eingebetteten Datenobjekt | {count} laufen auf eingebetteten Datenobjekten",
			attachedFraction: "{attached} von {available} Aktivitäten verknüpft",
			// Siehe en/process.ts. Unveränderlich, weil „jede/jeder/jedes“ dem Genus des
			// Datenobjekts folgen müsste — das steht erst zur Laufzeit fest, und ein
			// englischer Typname hat im Deutschen gar keins. „pro“ statt „je“: dasselbe
			// Wort wie im Hinweis darunter, und im Alltag geläufiger.
			each: "pro",
			// NOT " je ": the sentence around it is "Läuft einmal pro…", and pro and je are
			// synonyms — "pro TaxDetail je CoverLine" reads as the same word twice doing two
			// different jobs. "in" says containment instead, so the two stop competing.
			// The heading marker stays "je", where it has no such neighbour.
			perJoin: " in ",
			runsOncePer: "Läuft einmal pro {place}",
			thisDataobject: "dieses Datenobjekt",
			sectionNoneDefined: "keine definiert",
			deleted: "Aktivität gelöscht · Aktionen unbekannt",
		},
		cardinality: {
			attached: "Verknüpft",
			// Siehe en/process.ts: der Bereich zählt, was zur Laufzeit erzeugt wird, nicht
			// was hier verknüpft werden darf. Kein Hinweis nennt das Ziel — es steht in der
			// Überschrift, und ein genanntes Ziel bräuchte einen Artikel.
			allowed: "Zur Laufzeit erzeugt",
			capacityHint: "Zur Laufzeit erzeugt: {allowed}.",
			needsOne: "braucht eine Verknüpfung",
			emptyHint:
				"Nichts verknüpft, daher kann hier zur Laufzeit nichts erzeugt oder verknüpft werden. Verknüpfen Sie unten eines, oder ziehen Sie auf der Leinwand dieses Datenobjekt mit gedrückter {key}-Taste auf eines.",
			slotHint:
				"Alles, was diese Beziehung zur Laufzeit erhält, wird nach diesem Vorbild erzeugt.",
			lockedHint:
				"Verknüpfen Sie zuerst eines. Der Bereich legt fest, wie viele daraus erzeugt werden.",
			sharedFlag: "zur Laufzeit geteilt",
			sharedHint:
				"Ein anderes Datenobjekt dieser Art im Prozess hat hier ein eigenes verknüpft. Zur Laufzeit wird nur eines der beiden verwendet.",
			inheritedHint:
				"Ein anderes Datenobjekt dieser Art im Prozess hat hier eines verknüpft. Zur Laufzeit gilt es auch für dieses.",
			meaning: {
				any: "beliebig viele",
				oneOrMore: "eines oder mehr",
				atLeast: "{count} oder mehr",
				exactlyOne: "genau eines",
				exactly: "genau {count}",
				atMostOne: "höchstens eines",
				atMost: "höchstens {count}",
				between: "zwischen {min} und {max}",
			},
			rangeInvalid: "Ganze Zahlen verwenden oder * für unbegrenzt.",
			min: "Min",
			max: "Max",
			// Siehe en/process.ts: das Zeichen muss das sein, das `parseMax` akzeptiert.
			unboundedHint: "* für unbegrenzt.",
			maxInvalid: "Max muss * (unbegrenzt) oder ≥ Min sein.",
			noRelations: "Dieses Datenobjekt hat keine Beziehungen zur Auswahl.",
			noRelationsHint: "Definieren Sie zuerst Beziehungen im Informationsmodell.",
		},
	},
};
